import React, { useContext, useEffect } from 'react';
import {
	CreateStudioContext,
	ICreateStudioContext,
} from './createStudioModalContext/createStudioModalState/createStudioModalContext';
import Text from 'components/Text/Text';
import BtnBlock from './components/BtnBlock';
import NameField from './components/NameField';
import ModalWindows from './components/ModalWindows';
import { Form } from 'antd';
import { preventDefaultForEnterKey } from 'utils/helpers';
import classNames from 'classnames';
import style from './CreateStudioModal.module.scss';

interface ICreateStudioModal {
	isVisible: boolean;
}

const CreateStudioModal: React.FC<ICreateStudioModal> = ({ isVisible }) => {
	const { setDataForSubmit, changeTypeOfModalWindow, changeName, name } =
		useContext<ICreateStudioContext>(CreateStudioContext);

	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({ name });
	}, [name]);

	const submit = () => {
		setDataForSubmit({
			name,
		});
		changeTypeOfModalWindow('toConfirmSubmit');
	};

	return (
		<div className={containerClasses} data-test="CreateStudioModal">
			<Form form={form} name="basic" onFinish={submit} onKeyPress={preventDefaultForEnterKey} layout="vertical">
				<div className={style.wrapper}>
					<div className={style.content}>
						<Text
							className={style.heading}
							translationNameSpace="form"
							translationKey="cratingStudioHeading"
							size="xxl"
							weight="bold"
						/>
						<NameField changeName={changeName} />
					</div>
					<BtnBlock disabledSave={!name} changeTypeOfModalWindow={changeTypeOfModalWindow} />
				</div>
			</Form>
			<ModalWindows />
		</div>
	);
};

export default React.memo(CreateStudioModal);
